
import { defineComponent, onMounted, ref, reactive, computed, toRefs, inject } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import formService from "@/core/services/FormService"
import { useStore } from "vuex";
import { useI18n } from "vue-i18n/index";
export default defineComponent({
    props: {
        idevent: {
            type: null,
            required: true,
            default: 0
        }
    },
    emits: ['formLoaded'],
    setup(props, { emit }) {
        const ta = ref(process.env.VUE_APP_TA)
        const { t } = useI18n();
        const store = useStore();
        const loading = ref(false)
        const formQRef = ref<FormInstance>()
        const rules = reactive<FormRules>({})
        const formQ = reactive({
            save: 4,
            idevent: null,
            idinstitution: null,
            address: '',
            business: null,
            country: null,
            country_name: null,
            city: null,
            postalcode: null,
            phonecode: null,
            phone1: null,
            phone2: null,
            email: null,

            firstname: null,
            lastname: null,
            gender: null,
            nfunction: null,
            cphonecode: null,
            cphone1: null,
            cphone2: null,
            cemail: null,
            athletes: <any>[],
            functions: <any>[],
            mstatus: null
        })

        const idinstitution = inject<any>("idinstitution")
        const validatePhoneNumber = (rule: any, value: string, callback: Function) => {
            const phoneNumberRegex = /^[0-9]*$/;
            if (!value) {
                callback(new Error('Por favor, ingrese un número.'));
            } else if (!phoneNumberRegex.test(value)) {
                callback(new Error('Por favor, ingrese solo números.'));
            } else {
                callback();
            }
        };

        const handleInput = (field: string, event: InputEvent) => {
            const input = event.target as HTMLInputElement;
            const newValue = input.value.replace(/\D/g, ''); // Filtrar solo dígitos (números)
            formQ[field] = newValue; // Actualizar el valor del campo en el estado del formulario
        };

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const listCountry: any = computed<any>(() => {
            return store.getters.currentUser.country;
        });

        const accountUser: any = computed<any>(() => {
            return store.getters.currentUser.account;
        });

        const getGender: any = computed<any>(() => {
            return store.getters.currentUser.gender;
        })

        const getForm = async () => {
            loading.value = true;
            resetForm(formQRef.value)
            let query = (idinstitution) ? `show?idinstitution=${idinstitution.value}` : 'show'
            formService.getForm(`${props.idevent}/1`, query)
                .then((res) => {
                    Object.assign(formQ, res.data)
                    loading.value = false
                    emit('formLoaded');
                }).catch(({ response }) => {
                    loading.value = false
                })
        }

        const updateTotal = (index: number) => {
            const sport = formQ.athletes[index];
            sport.total = parseInt(sport.men) + parseInt(sport.women);
        };

        onMounted(() => {
            getForm()
        })

        return {
            t,
            ta,
            //listSports,
            loading,
            formQ,
            formQRef,
            rules,
            listCountry,
            ...toRefs(formQ),
            //methods
            getForm,
            updateTotal,
            validatePhoneNumber,
            handleInput,
            getGender,
            accountUser,
        }

    },
})
